<template>
  <div>
      <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
          <app-sidebar></app-sidebar>
          <div id="page-content-wrapper" style="width:100%">
              <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar" style="cursor:pointer">view_headline</i>
              <app-navbar></app-navbar>
              <div class="container-fluid mt-5">
                  <div class="col-sm-12">
                      <div class="row dblock">
                          <div class="row">
                              <div class="col-md-12">
                                  <vs-breadcrumb align="left" :items="
                    [
                      {title: 'You are here : '},
                      {
                        title: 'Reports',
                        active: true
                      }
                    ]"></vs-breadcrumb>
                                  <div class="heading mt-3">
                                      <h3 class="text-secondary">Reports</h3>
                                  </div>
                              </div>
                          </div>
  
                         <AllReports/>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  </template>
  
  <script>
  import Navbar from "./Navbar";
  import Sidebar from "./Sidebar";
  import AllReports from "../../commonPages/AllReports.vue";
 
  export default {
      data: () => ({
          isSidebar: false,
          
      }),
     
      components: {
          "app-navbar": Navbar,
          "app-sidebar": Sidebar,
           AllReports
      },
    
  };
  </script>
  
  <style scoped>
  #menu-toggle {
      display: none;
  }
  
  @media (max-width: 768px) {
      #menu-toggle {
          display: block;
      }
  }
  
 
    
  </style>
  